import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AppPopup, AppQueryPopupsController } from "./AppQueryPopupsBloc";
import { APP_CHAT_PATH } from "src/lib/createAppPath";

export const PathnameToPopupMap: Record<string, AppPopup | undefined> = {
  [`${APP_CHAT_PATH}/action/upload-blood-pressure`]:
    AppPopup.enterBloodPressure,
  [`${APP_CHAT_PATH}/action/upload-waist-circumference`]:
    AppPopup.enterWaistCircumference,
  [`${APP_CHAT_PATH}/action/upload-weight`]: AppPopup.enterWeight,
  [`${APP_CHAT_PATH}/action/upload-lab-report`]: AppPopup.uploadLabReport,
  [`${APP_CHAT_PATH}/action/upload-blood-glucose`]: AppPopup.enterBloodGlucose
};

const AppQueryPopupsRedirects = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const popup = PathnameToPopupMap[pathname];

    if (popup) {
      AppQueryPopupsController.openPopup(popup, { replace: true });
      // eslint-disable-next-line no-console
      console.warn(
        `Redirecting to popup, please link to "?popup=${popup}" instead`,
        popup
      );
    }
  }, [pathname]);

  return null;
};

export default AppQueryPopupsRedirects;
